import CommissionListingV1 from 'components/CommissionListingV1';
import SalesReport from 'components/SalesReport';
import { useViewport } from 'utils/responsive';
import Header from 'widgets/header';
import Tabs from 'widgets/tabs';
import { dashboardConfigs, Tabs as TABTYPES } from './configs';
import * as Styles from './styles';

const ReportDashboard = () => {
    const { isMobile } = useViewport();
    const { title } = dashboardConfigs;

    return (
        <>
            <Header
                wrapperStyles={{
                    maxWidth: isMobile ? '100%' : '80%',
                    margin: '0 auto',
                    padding: '20px',
                }}
            />
            <Styles.Hr />
            <Styles.Wrapper>
                <Styles.Header>
                    <Styles.HeaderTextWrapper>
                        <Styles.HeaderText>{title}</Styles.HeaderText>
                    </Styles.HeaderTextWrapper>
                </Styles.Header>
                <Styles.MainCard>
                    <Tabs
                        tabs={[
                            {
                                id: TABTYPES.REPORT_DASHBOARD,
                                label: 'Dashboard',
                                component: <SalesReport />,
                            },
                            {
                                id: TABTYPES.DOWNLOAD_HISTORY,
                                label: 'Download Reports',
                                component: <CommissionListingV1 />,
                            },
                        ]}
                        defaultTab={TABTYPES.REPORT_DASHBOARD}
                        onChange={() => {}}
                    />
                </Styles.MainCard>
            </Styles.Wrapper>
        </>
    );
};

export default ReportDashboard;
